"use client";
import { createContext as e } from "react";
const s = e({
  isHeader: !1,
  isStickyHeader: !1,
  size: "medium"
});
export {
  s as T
};
